<template>
  <div class="site-blocks-cover" data-aos="fade" data-stellar-background-ratio="0.5">
    <div class="container">
      <div class="row row-custom align-items-center">
        <div class="col-md-10">
          <h1 class="mb-2 text-black w-75"><span class="font-weight-bold"></span></h1>
          <div class="job-search">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active py-3" id="pills-job-tab" data-toggle="pill" href="#joblistings" role="tab" aria-controls="pills-job" aria-selected="true">Find A Job</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
<!--   end of 1st component(search bar and top panel) -->

  <div class="site-section bg-light">
    <div class="container">
      <div class="row justify-content-start text-left mb-5">
        <div class="col-md-9" data-aos="fade">
          <h2 class="font-weight-bold text-black">Recent Jobs</h2>
        </div>
      </div>
      <!-- start of job listing component -->
      <JobListings :jobs="jobs" />
      <!--End of joblistings-->
    </div>
  </div>
</template>

<script>
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../../assets/css/magnific-popup.css'
import '../../assets/css/icomoon-style.css'
/* import '../../assets/css/jquery-ui.css' */
import '../../assets/css/owl.carousel.min.css'
import '../../assets/css/bootstrap-datepicker.css'
import '../../assets/css/animate.css'
import '../../assets/css/flaticon.css'
import '../../assets/css/fl-bigmug-line.css'

import JobListings from '../../components/JobListings.vue'
import { ref } from 'vue'
import axios from 'axios'
export default {
  name: 'Jobs',
  components: {JobListings},
  setup() {
    const jobs = ref([])
    
    axios.get('https://cybershield-24f97-default-rtdb.firebaseio.com/jobs.json')
    .then(response => {
      const data = response.data;
      const keyValuePairs = [];

      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          const nestedObject = data[key];
          const formattedObject = {};

          for (let nestedKey in nestedObject) {
            if (nestedObject.hasOwnProperty(nestedKey)) {
              const value = nestedObject[nestedKey];
              formattedObject[nestedKey] = value;
            }
          }

          keyValuePairs.push(formattedObject);
        }
      }
      jobs.value = keyValuePairs
      console.log(jobs)
      
    })
    .catch(error => {
      console.log(error);
    });

    return { jobs }
  }
}
</script>

<style scoped>

body {
  line-height: 1.7;
  color: #4d4d4d;
  font-weight: 400;
  font-size: 1rem;
  font-family: "Roboto Mono", SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-family: "Nunito Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; }

::selection {
  background: #000;
  color: #fff; }

.line-height-sm {
  line-height: 1.4 !important; }

a {
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease; }
  a:hover {
    text-decoration: none; }

.text-black {
  color: #000 !important; }

.line-height-sm {
  line-height: 1.3; }

.site-wrap:before {
  -webkit-transition: .3s all ease-in-out;
  -o-transition: .3s all ease-in-out;
  transition: .3s all ease-in-out;
  background: rgba(0, 0, 0, 0.6);
  content: "";
  position: absolute;
  z-index: 2000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  visibility: hidden; }

.offcanvas-menu .site-wrap {
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 2;
  overflow: hidden; }
  .offcanvas-menu .site-wrap:before {
    opacity: 1;
    visibility: visible; }

.btn {
  position: relative;
  top: 0; }
  .btn:hover, .btn:active, .btn:focus {
    outline: none;
    -webkit-box-shadow: none !important;
    box-shadow: none !important; }
  .btn.btn-secondary {
    background-color: #e6e7e9;
    border-color: #e6e7e9;
    color: #000; }
  .btn.btn-primary {
    color: #fff; }

.form-control {
  height: 47px; }
  .form-control:active, .form-control:focus {
    border-color: #26baee; }
  .form-control:hover, .form-control:active, .form-control:focus {
    -webkit-box-shadow: none !important;
    box-shadow: none !important; }

.site-section {
  padding: 3em 0; }
  @media (min-width: 768px) {
    .site-section {
      padding: 7em 0; } }

.site-footer {
  padding: 7em 0;
  background: #393e46;
  color: rgba(255, 255, 255, 0.4); }
  .site-footer a {
    color: rgba(255, 255, 255, 0.7); }
    .site-footer a:hover {
      color: #fff; }
  .site-footer .footer-heading {
    font-size: 18px;
    color: #fff; }
  .site-footer ul li {
    margin-bottom: 10px; }

.text-gray-500 {
  color: #adb5bd !important; }

/* Navbar */

.site-navbar {
  margin-bottom: 0px;
  width: 100%;
  border-bottom: none;
  z-index: 2;
  position: relative; }
  .site-navbar .site-navigation .site-menu {
    margin-bottom: 0;
    margin-left: 0;
    padding-left: 0; }
    .site-navbar .site-navigation .site-menu .active > a {
      color: #000; }
    .site-navbar .site-navigation .site-menu a {
      text-decoration: none !important;
      display: inline-block; }
    .site-navbar .site-navigation .site-menu > li {
      display: inline-block;
      padding: 10px 5px; }
      .site-navbar .site-navigation .site-menu > li > a {
        padding: 10px 10px;
        letter-spacing: .05em;
        color: rgba(0, 0, 0, 0.6);
        text-decoration: none !important; }
        .site-navbar .site-navigation .site-menu > li > a:hover {
          color: #000; }
      .site-navbar .site-navigation .site-menu > li:last-child {
        padding-right: 0; }
        .site-navbar .site-navigation .site-menu > li:last-child > a {
          padding-right: 0; }
    .site-navbar .site-navigation .site-menu .has-children {
      position: relative; }
      .site-navbar .site-navigation .site-menu .has-children > a {
        position: relative;
        padding-right: 20px; }
        .site-navbar .site-navigation .site-menu .has-children > a:before {
          position: absolute;
          content: "\e313";
          font-size: 16px;
          top: 50%;
          right: 0;
          -webkit-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          transform: translateY(-50%);
          font-family: 'icomoon'; }
      .site-navbar .site-navigation .site-menu .has-children .dropdown {
        visibility: hidden;
        opacity: 0;
        top: 100%;
        position: absolute;
        text-align: left;
        -webkit-box-shadow: 0 2px 10px -2px rgba(0, 0, 0, 0.25);
        box-shadow: 0 2px 10px -2px rgba(0, 0, 0, 0.25);
        border-left: 1px solid #edf0f5;
        border-right: 1px solid #edf0f5;
        border-bottom: 1px solid #edf0f5;
        padding: 10px 0;
        margin-top: 20px;
        margin-left: 0px;
        background: #fff;
        -webkit-transition: 0.2s 0s;
        -o-transition: 0.2s 0s;
        transition: 0.2s 0s; }
        .site-navbar .site-navigation .site-menu .has-children .dropdown a {
          text-transform: none;
          letter-spacing: normal;
          -webkit-transition: 0s all;
          -o-transition: 0s all;
          transition: 0s all;
          color: #343a40; }
        .site-navbar .site-navigation .site-menu .has-children .dropdown .active > a {
          color: #000 !important; }
        .site-navbar .site-navigation .site-menu .has-children .dropdown > li {
          list-style: none;
          padding: 0;
          margin: 0;
          min-width: 200px; }
          .site-navbar .site-navigation .site-menu .has-children .dropdown > li > a {
            padding: 5px 20px;
            display: block; }
            .site-navbar .site-navigation .site-menu .has-children .dropdown > li > a:hover {
              color: #26baee; }
          .site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children > a:before {
            content: "\e315";
            right: 20px; }
          .site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children > .dropdown, .site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children > ul {
            left: 100%;
            top: 0; }
          .site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children:hover > a, .site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children:active > a, .site-navbar .site-navigation .site-menu .has-children .dropdown > li.has-children:focus > a {
            color: #26baee; }
      .site-navbar .site-navigation .site-menu .has-children:hover > a, .site-navbar .site-navigation .site-menu .has-children:focus > a, .site-navbar .site-navigation .site-menu .has-children:active > a {
        color: #26baee; }
      .site-navbar .site-navigation .site-menu .has-children:hover, .site-navbar .site-navigation .site-menu .has-children:focus, .site-navbar .site-navigation .site-menu .has-children:active {
        cursor: pointer; }
        .site-navbar .site-navigation .site-menu .has-children:hover > .dropdown, .site-navbar .site-navigation .site-menu .has-children:focus > .dropdown, .site-navbar .site-navigation .site-menu .has-children:active > .dropdown {
          -webkit-transition-delay: 0s;
          -o-transition-delay: 0s;
          transition-delay: 0s;
          margin-top: 0px;
          visibility: visible;
          opacity: 1; }

.site-mobile-menu {
  width: 300px;
  position: fixed;
  right: 0;
  z-index: 2000;
  padding-top: 20px;
  background: #fff;
  height: calc(100vh);
  -webkit-transform: translateX(110%);
  -ms-transform: translateX(110%);
  transform: translateX(110%);
  -webkit-box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
  box-shadow: -10px 0 20px -10px rgba(0, 0, 0, 0.1);
  -webkit-transition: .3s all ease-in-out;
  -o-transition: .3s all ease-in-out;
  transition: .3s all ease-in-out; }
  .offcanvas-menu .site-mobile-menu {
    -webkit-transform: translateX(0%);
    -ms-transform: translateX(0%);
    transform: translateX(0%); }
  .site-mobile-menu .site-mobile-menu-header {
    width: 100%;
    float: left;
    padding-left: 20px;
    padding-right: 20px; }
    .site-mobile-menu .site-mobile-menu-header .site-mobile-menu-close {
      float: right;
      margin-top: 8px; }
      .site-mobile-menu .site-mobile-menu-header .site-mobile-menu-close span {
        font-size: 30px;
        display: inline-block;
        padding-left: 10px;
        padding-right: 0px;
        line-height: 1;
        cursor: pointer;
        -webkit-transition: .3s all ease;
        -o-transition: .3s all ease;
        transition: .3s all ease; }
        .site-mobile-menu .site-mobile-menu-header .site-mobile-menu-close span:hover {
          color: #25262a; }
  .site-mobile-menu .site-mobile-menu-body {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    position: relative;
    padding: 20px;
    height: calc(100vh - 52px);
    padding-bottom: 150px; }
  .site-mobile-menu .site-nav-wrap {
    padding: 0;
    margin: 0;
    list-style: none;
    position: relative; }
    .site-mobile-menu .site-nav-wrap a {
      padding: 10px 20px;
      display: block;
      position: relative;
      color: #212529; }
      .site-mobile-menu .site-nav-wrap a:hover {
        color: #26baee; }
    .site-mobile-menu .site-nav-wrap li {
      position: relative;
      display: block; }
      .site-mobile-menu .site-nav-wrap li.active > a {
        color: #26baee; }
    .site-mobile-menu .site-nav-wrap .arrow-collapse {
      position: absolute;
      right: 0px;
      top: 10px;
      z-index: 20;
      width: 36px;
      height: 36px;
      text-align: center;
      cursor: pointer;
      border-radius: 50%; }
      .site-mobile-menu .site-nav-wrap .arrow-collapse:hover {
        background: #f8f9fa; }
      .site-mobile-menu .site-nav-wrap .arrow-collapse:before {
        font-size: 12px;
        z-index: 20;
        font-family: "icomoon";
        content: "\f078";
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%) rotate(-180deg);
        -ms-transform: translate(-50%, -50%) rotate(-180deg);
        transform: translate(-50%, -50%) rotate(-180deg);
        -webkit-transition: .3s all ease;
        -o-transition: .3s all ease;
        transition: .3s all ease; }
      .site-mobile-menu .site-nav-wrap .arrow-collapse.collapsed:before {
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%); }
    .site-mobile-menu .site-nav-wrap > li {
      display: block;
      position: relative;
      float: left;
      width: 100%; }
      .site-mobile-menu .site-nav-wrap > li > a {
        padding-left: 20px;
        font-size: 20px; }
      .site-mobile-menu .site-nav-wrap > li > ul {
        padding: 0;
        margin: 0;
        list-style: none; }
        .site-mobile-menu .site-nav-wrap > li > ul > li {
          display: block; }
          .site-mobile-menu .site-nav-wrap > li > ul > li > a {
            padding-left: 40px;
            font-size: 16px; }
          .site-mobile-menu .site-nav-wrap > li > ul > li > ul {
            padding: 0;
            margin: 0; }
            .site-mobile-menu .site-nav-wrap > li > ul > li > ul > li {
              display: block; }
              .site-mobile-menu .site-nav-wrap > li > ul > li > ul > li > a {
                font-size: 16px;
                padding-left: 60px; }

/* Blocks */
.site-blocks-cover {
  background-image: url(../../assets/img/bg-masthead.jpg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top; }
  .site-blocks-cover.overlay {
    position: relative; }
    .site-blocks-cover.overlay:before {
      position: absolute;
      content: "";
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.4); }
  .site-blocks-cover, .site-blocks-cover .row-custom {
    min-height: 600px;
    height: calc(100vh); }
  .site-blocks-cover h1 {
    font-weight: 900;
    color: #fff;
    font-size: 3rem; }
    .site-blocks-cover h1 strong {
      font-weight: 900; }
    @media (min-width: 768px) {
      .site-blocks-cover h1 {
        font-size: 5rem;
        font-weight: 300;
        line-height: 1.2; } }
  .site-blocks-cover p {
    color: #fff;
    font-size: 1.5rem;
    line-height: 1.5; }

 .slide-one-item {
  position: relative;
  z-index: 1; }
   .slide-one-item .owl-nav {
    position: relative;
    position: absolute;
    bottom: 0px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    transform: translateX(-50%); }
     .slide-one-item .owl-nav .owl-prev, .slide-one-item .owl-nav .owl-next {
      position: relative;
      display: inline-block;
      padding: 20px;
      font-size: 30px;
      color: #fff; }
       .slide-one-item .owl-nav .owl-prev.disabled, .slide-one-item .owl-nav .owl-next.disabled {
        opacity: .2; }

#date-countdown .countdown-block {
  color: rgba(255, 255, 255, 0.4); }

#date-countdown .label {
  font-size: 40px;
  color: #fff; }

.player {
  position: relative; }
  .player img {
    max-width: 100px;
    border-radius: 50%;
    margin-bottom: 20px; }
  .player h2 {
    font-size: 20px;
    letter-spacing: .2em;
    text-transform: uppercase; }
  .player .position {
    font-size: 14px;
    color: #b3b3b3;
    text-transform: uppercase; }

.site-block-27 ul, .site-block-27 ul li {
  padding: 0;
  margin: 0; }

.site-block-27 ul li {
  display: inline-block;
  margin-bottom: 4px; }
  .site-block-27 ul li i {
    position: relative;
    top: 2px; }
  .site-block-27 ul li a, .site-block-27 ul li span {
    text-align: center;
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    border: 1px solid #ccc; }
  .site-block-27 ul li.active a, .site-block-27 ul li.active span {
    background: #26baee;
    color: #fff;
    border: 1px solid transparent; }

.site-block-check {
  padding: 0;
  margin: 0 0 30px 0; }
  .site-block-check li {
    padding: 0;
    margin: 0; }
  .site-block-check li {
    display: block;
    padding-left: 30px;
    position: relative;
    margin-bottom: 10px; }
    .site-block-check li:before {
      position: absolute;
      color: #7cbd1e;
      left: 0;
      top: -.3rem;
      font-family: 'icomoon';
      font-size: 1.1rem;
      content: "\e5ca"; }

.select-wrap {
  position: relative; }
  .select-wrap select {
    padding-right: 30px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; }
  .select-wrap .arrow-down, .select-wrap .icon {
    position: absolute;
    right: 10px;
    top: 50%;
    font-size: 20px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%); }

.unit-3 {
  padding: 30px;
  border: 2px solid #e6e6e6;
  position: relative;
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease; }
  .unit-3 .unit-3-heading, .unit-3 .unit-3-body {
    position: relative;
    z-index: 2; }
  .unit-3 .unit-3-icon-wrap {
    position: relative;
    height: 68px;
    width: 59px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 59px;
    flex: 0 0 59px; }
  .unit-3 .unit-3-svg {
    position: absolute;
    stroke: #e9ecef;
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease; }
  .unit-3 .unit-3-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 2rem;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease; }
  .unit-3 p {
    color: #b3b3b3; }
  .unit-3:hover {
    border: 2px solid #26baee; }

.block-4 .nonloop-block-4 .owl-stage {
  padding-bottom: 2em; }

.block-4 .nonloop-block-4 .owl-nav {
  z-index: 2;
  position: absolute;
  width: 100%;
  bottom: -2px; }
  .block-4 .nonloop-block-4 .owl-nav .owl-prev, .block-4 .nonloop-block-4 .owl-nav .owl-next {
    opacity: .2;
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease;
    position: absolute; }
    .block-4 .nonloop-block-4 .owl-nav .owl-prev:hover, .block-4 .nonloop-block-4 .owl-nav .owl-next:hover {
      opacity: 1; }
    .block-4 .nonloop-block-4 .owl-nav .owl-prev.disabled, .block-4 .nonloop-block-4 .owl-nav .owl-next.disabled {
      display: none; }
    .block-4 .nonloop-block-4 .owl-nav .owl-prev span, .block-4 .nonloop-block-4 .owl-nav .owl-next span {
      font-size: 30px; }
  .block-4 .nonloop-block-4 .owl-nav .owl-prev {
    left: 50px; }
  .block-4 .nonloop-block-4 .owl-nav .owl-next {
    right: 50px; }

.block-4 .nonloop-block-4 .owl-dots {
  bottom: -40px;
  position: absolute;
  width: 100%;
  text-align: center; }
  .block-4 .nonloop-block-4 .owl-dots .owl-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: #ccc;
    border-radius: 50%;
    margin-right: 10px;
    margin-bottom: 10px;
    -webkit-transition: .3s all ease;
    -o-transition: .3s all ease;
    transition: .3s all ease; }
    .block-4 .nonloop-block-4 .owl-dots .owl-dot.active {
      background: #26baee; }

.block-38 {
  text-align: center; }
  .block-38 .block-38-header .block-38-heading {
    font-size: 18px;
    color: #000;
    margin: 0;
    font-weight: 300; }
  .block-38 .block-38-header .block-38-subheading {
    color: #b3b3b3;
    margin: 0 0 20px 0;
    text-transform: uppercase; }
  .block-38 .block-38-header img {
    width: 90px;
    margin: 0 auto;
    border-radius: 50%;
    margin-bottom: 20px; }
  .block-38 .block-38-body {
    font-size: 1.1rem; }

.unit-5 {
  padding-top: 50px;
  padding-bottom: 50px;
  background-size: cover;
  background-position: center center; }
  .unit-5.overlay {
    position: relative; }
    .unit-5.overlay:before {
      position: absolute;
      content: "";
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      z-index: 1;
      background: rgba(0, 0, 0, 0.5); }
  .unit-5 > .container {
    z-index: 2;
    position: relative; }
  .unit-5 h2 {
    color: #fff;
    font-size: 3rem; }

.unit-6 {
  color: #fff; }
  .unit-6 .sep {
    color: rgba(255, 255, 255, 0.2);
    margin: 0 10px; }

.unit-8 .accordion-item .heading {
  font-size: 1.2rem;
  font-weight: 400;
  padding: 10px 0; }
  .unit-8 .accordion-item .heading > a {
    padding-left: 35px;
    position: relative;
    color: #000; }
    .unit-8 .accordion-item .heading > a:before {
      width: 20px;
      height: 20px;
      line-height: 18px;
      border: 1px solid #ccc;
      text-align: center;
      font-size: 18px;
      top: .1em;
      left: 0; }
    .unit-8 .accordion-item .heading > a[aria-expanded="true"]:before {
      font-family: 'icomoon';
      position: absolute;
      content: "\e316";
      -webkit-transition: .3s all ease;
      -o-transition: .3s all ease;
      transition: .3s all ease;
      background: #26baee;
      color: #fff;
      border: 1px solid #26baee; }
    .unit-8 .accordion-item .heading > a[aria-expanded="false"]:before {
      content: "\e313";
      color: #ccc;
      font-family: 'icomoon';
      position: absolute;
      -webkit-transition: .3s all ease;
      -o-transition: .3s all ease;
      transition: .3s all ease; }

.unit-8 .accordion-item .body-text {
  padding: 5px 0;
  padding-left: 30px; }

.job-search .btn {
  height: 47px; }

.job-search > ul {
  position: relative;
  z-index: 1;
  top: 20px; }
  .job-search > ul a {
    text-transform: uppercase;
    color: #000;
    font-size: 13px;
    padding: 100px 100px;
    font-weight: bold;
    letter-spacing: .1em; }

.job-search .tab-content {
  position: relative;
  z-index: 2; }

.job-search{
  align-items: center;
}

.job-post-item {
  background: #fff;
  position: relative;
  -webkit-transition: .1s all ease;
  -o-transition: .1s all ease;
  transition: .1s all ease;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1); }
  .job-post-item .btn-favorite {
    width: 40px;
    height: 40px;
    line-height: 40px;
    padding: 0 !important;
    margin: 0 !important; }
    .job-post-item .btn-favorite.active, .job-post-item .btn-favorite:hover {
      border-color: #f23a2e;
      background: #f23a2e;
      color: #fff !important; }
  .job-post-item.last {
    border-bottom: 1px solid transparent; }
  .job-post-item .badge-wrap {
    position: relative;
    top: -5px; }
  .job-post-item .badge {
    border-radius: 30px; }
  .job-post-item:hover, .job-post-item:focus {
    -webkit-box-shadow: 0 0 40px -5px rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 40px -5px rgba(0, 0, 0, 0.2);
    top: -5px;
    z-index: 2; }

.unit-8 .img-a img {
  opacity: 1;
  -webkit-transition: .2s all ease-in-out;
  -o-transition: .2s all ease-in-out;
  transition: .2s all ease-in-out;
  top: 0;
  position: relative; }

.unit-8:hover .img-a img {
  opacity: .5;
  top: -5px; }

.top-destination .place {
  display: block;
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  transition: .3s all ease; }
  .top-destination .place:hover, .top-destination .place:focus {
    opacity: .7; }
  .top-destination .place img {
    max-width: 100%;
    margin-bottom: 20px; }
  .top-destination .place h2 {
    font-size: 18px;
    line-height: 1.5; }
  .top-destination .place p {
    font-size: 13px;
    color: #ccc; }
</style>